export default "__VITE_ASSET__CjnATUvq__"